import { useDataKeysStore } from "@/encryption";
import { useChatStore } from "@/sdk";
import type { CreateSdkParams } from "@/utils/createAgentSdk";

export function getStatelessCacheActions(): Pick<CreateSdkParams, "chatMessagesCache" | "dataKeysCache"> {
    const addDataKey = useDataKeysStore.getState().addDataKey;
    const removeDataKey = useDataKeysStore.getState().removeDataKey;
    const findDataKeyByContext = useDataKeysStore.getState().findDataKeyByContext;
    const findDataKeyByEncryptionKey = useDataKeysStore.getState().findDataKeyByEncryptionKey;

    const addChatMessages = useChatStore.getState().addChatMessages;
    const removeChatMessages = useChatStore.getState().removeChatMessages;
    const updateChatMessages = useChatStore.getState().updateChatMessages;

    const markCustomerIsTyping = useChatStore.getState().markCustomerIsTyping;
    const markCustomerStoppedTyping = useChatStore.getState().markCustomerStoppedTyping;

    return {
        dataKeysCache: {
            addDataKey,
            removeDataKey,
            findDataKeyByContext,
            findDataKeyByEncryptionKey,
        },
        chatMessagesCache: {
            addChatMessages,
            removeChatMessages,
            updateChatMessages,
            markCustomerIsTyping,
            markCustomerStoppedTyping,
        },
    };
}
